<template>
  <div class="userInfo">
    <div class="main-title">完善信息</div>
    <div class="changeTypesBox">
      <el-radio v-model="type" :label="2" :disabled="state==1?true:false">个体经营</el-radio>
      <el-radio v-model="type" :label="3" :disabled="state==1?true:false">企业用户</el-radio>
      <el-radio v-model="type" :label="4" :disabled="state==1?true:false">事业单位或社会团体</el-radio>
    </div>
    <div class="curTypebox">
      <SinglePerson v-if="type == 2" :type ="type"/>
      <CompanyPerson v-if="type == 3" :type ="type"/>
      <PublicInstitutionPerson v-if="type == 4" :type ="type"/>
    </div>
  </div>
</template>

<script>
import imagesUrl from '../../../assets/imagesUrl'
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
import {mapGetters, mapMutations} from 'vuex'
import CompanyPerson from '../companyCertificate/pages/companyPerson.vue'
import SinglePerson from '../companyCertificate/pages/singlePerson.vue'
import PublicInstitutionPerson from '../companyCertificate/pages/publicInstitutionPerson.vue'
export default {
  mixins: [listSearchMixin],
  name: 'companyCertificate',
  components:{
    CompanyPerson,
    SinglePerson,
    PublicInstitutionPerson
  },
  data () {
    return {
      type:3,
      state:0,
      headUrl: imagesUrl.avatar,
      userName: 'Curmudgeons',
      gender: '1',
      birthTime: '',
      userInfoData: {},
      avatarImg: '',
      action: api.upload
    }
  },
  mounted () {
    this.getEnterpriseCheckData()
  },
  computed: {
    ...mapGetters([
      'userInfo' // 用户信息
    ])
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USERINFO', // 修改用户信息
      setAVATR: 'SET_AVATAR' // 修改用户信息
    }),
    getEnterpriseCheckData() {
      //获取提交过的认证信息
      let params = {
        url: api.enterpriseGetData,
        method: "POST",
        data: {},
      };
      let _this = this
      this.sendReq(params, (res) => {
        if(res.code == '200'){
          _this.type = res.data.authenType
          _this.state = res.data.state
          
        }
        
      });
    },
    // 获取用户信息
    getUserInfo() {
      let self = this;
      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      self.sendReq(params, (res) => {
        
        if (res.code === "200") {
          self.setUserInfo(res.data);
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    saveUserInfo() {
      // if(this.form.name == ''){
      //   this.$message({
      //       message: "昵称不能为空",
      //       type: "warning",
      //     });
      //     return;
      // }
      // console.log(this.userInfo, 'userInfo')
      let self = this;
      self.userInfo.name = self.userInfo.account
      let params = {
        url: api.editUserInfo,
        method: "post",
        data: {
          name: self.userInfo.name,
          sex: self.userInfo.sex,
          birthday: self.userInfo.birthday,
          headImage: self.userInfo.headImage
        }
      };
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.$message({
            message: '修改成功！',
            type: 'success'
          })
          this.getUserInfo()
        }
      })
    },
    // saveUserInfo () {
    //   // console.log(this.userInfo, 'userInfo')
    //   let self = this
    //   let params = {
    //     url: api.update,
    //     method: 'PUT',
    //     data: {
    //       name: self.userInfo.name,
    //       sex: self.userInfo.sex,
    //       birthday: self.userInfo.birthday,
    //       headImage: self.userInfo.headImage
    //     }
    //   }
    //   self.sendReq(params, (res) => {
    //     if (res.code === '200') {
    //       self.$message({
    //         message: '修改成功！',
    //         type: 'success'
    //       })
    //       this.getUserInfo()
    //     }
    //   })
    // },
    // 上传头像
    handleAvatarSuccess (res) {
      this.setAVATR(res.data.url)
      this.saveUserInfo()
    }
  }
}
</script>
<style>
  .main{
    background: #F5F5F5;
  }
</style>
<style lang="scss" scoped>
.userInfo {
  padding: 30px;
  background: #ffffff;
  // border: 1px solid #E5E5E5;
  .main-title{
    font-size: 22px;
    text-align: center;
    font-weight: bold;
    color: #333333;
    margin-bottom: 42px;
  }
  .changeTypesBox{
    text-align: center;
    margin-bottom: 58px;
    
    label{
      color: #999;
      margin-right: 144px;
    }
    label:last-child{
      margin-right: 0;
    }
  }
  .curTypebox{
    width: 66%;
    margin: 0 auto;
  }
  .changeAvatar {
    width: 134px;
    height: 134px;
    position: relative;
    .avatar {
      width: 100%;
    }
    .avatarTit {
      height: 30px;
      line-height: 30px;
      position: absolute;
      bottom: 0;
      font-size: 16px;
      background: rgba(84, 84, 84, 0.5);
      width: 100%;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .userNameBox {
    >>> .el-input {
      width: 180px;
    }
  }
  .userBlock {
    margin-top: 30px;
    display: flex;
    align-items: center;
    label {
      font-weight: normal;
      font-size: 16px;
      color: #666666;
    }
  }
  .bindPhoneBox {
    .phoneInfo {
      font-size: 16px;
      span {
        margin-right: 15px;
        text-decoration: underline;
        cursor: pointer;
      }
      span:nth-child(1) {
        color: #333333;
        text-decoration: none;
        cursor: default;
      }
      span:nth-child(2) {
        color: $mainColor;
      }
      span:nth-child(3) {
        color: #666666;
      }
    }
  }
  .userInfoSave {
    margin: 50px 0 0 80px;
    width: 115px;
    height: 30px;
    line-height: 30px;
    background: #FFFFFF;
    border: 1px solid $mainColor;
    border-radius: 4px;
    text-align: center;
    color: $mainColor;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/companyCertificate/companyCertificate.vue